import React from 'react';

// Official PlannerPRO brand logo (globe P). White-based artwork shown as an app-icon chip.
export const Brand = ({ size = 40, showText = true, textClass = '', variant = 'principal' }) => {
  const src = `/brand/logo-${variant}.jpg`;
  return (
    <div className="flex items-center gap-2.5">
      <div className="rounded-2xl overflow-hidden shrink-0 pp-glow-mint bg-white" style={{ width: size, height: size }}>
        <img src={src} alt="PlannerPRO" className="w-full h-full object-cover" />
      </div>
      {showText && (
        <span className={textClass || 'text-lg font-extrabold tracking-tight'}>
          Planner<span className="pp-gold">PRO</span>
        </span>
      )}
    </div>
  );
};
